export default __webpack_public_path__ + "static/media/burger-logo.ec69c7f6.png";